import { Input } from "./input";
import { Textarea } from "./textarea";
import { Select } from "./select";
import { Button } from "./button";
import { Link } from "./link";
import { List } from "./list";
import { Tooltip } from "./tooltip";
import { Checkbox } from "./checkbox";

export const components = {
  Button,
  Link,
  List,
  Input,
  Textarea,
  Select,
  Tooltip,
  Checkbox,
};
